
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Car, LogIn } from "lucide-react";
import { getAssetPath } from "@/utils/assetUtils";

interface VehicleLayoutProps {
  children: React.ReactNode;
  title: string;
}

export const VehicleLayout = ({ children, title }: VehicleLayoutProps) => {
  const [logoLoaded, setLogoLoaded] = useState(false);
  
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <header className="bg-black p-4">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
          <Link to="/" className="text-white flex items-center">
            {!logoLoaded && <span className="font-bold text-xl">DISCO</span>}
            <img 
              src={getAssetPath("disco_logo.png")} 
              alt="Disco Logo" 
              className={`h-8 ${logoLoaded ? 'block' : 'hidden'}`}
              onLoad={() => setLogoLoaded(true)}
              onError={() => {
                console.error("Failed to load logo in VehicleLayout");
                // Keep text fallback visible
              }}
            />
          </Link>
          <Link to="/login" className="text-white text-sm flex items-center gap-1 hover:opacity-80 transition-opacity">
            <LogIn size={16} />
            Log in
          </Link>
        </div>
      </header>

      <main className="flex-grow flex items-center justify-center py-12 px-4">
        <div className="bg-white rounded-lg shadow-sm w-full max-w-3xl p-8">
          <div className="flex justify-center mb-6">
            <div className="h-12 w-12 rounded-full bg-black flex items-center justify-center">
              <Car className="h-6 w-6 text-green-400" />
            </div>
          </div>
          
          <h1 className="text-center text-2xl font-normal mb-6 text-black">
            {title}
          </h1>
          
          {children}
        </div>
      </main>

      <footer className="bg-black text-white py-3 px-4 text-xs">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
          <div>©2025 Disco. All Rights Reserved</div>
          <div className="flex gap-3">
            <a 
              href="https://www.discoveryconciergeservices.com/terms-conditions" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Terms & Conditions
            </a>
            <span>|</span>
            <a 
              href="https://www.discoveryconciergeservices.com/privacy-policy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};
